'use strict'

import TypesenseError from './TypesenseError'

export default class ObjectNotFound extends TypesenseError {}
